import _ from 'lodash';
import { makeObservable, observable, action } from 'mobx';

import CMDBApi from '../api/CMDBApi';

class AwrStore {
  isLoading = false;
  isExporting = false;
  rows = [];
  totalCount = 0;
  page = 0;
  pageSize = 50;
  currentEids = [];
  currentLocationCodes = [];

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      isExporting: observable,
      rows: observable,
      totalCount: observable,
      page: observable,
      pageSize: observable,
      fetchMongoUsers: action,
      exportMongoUsers: action,
      setPage: action,
      setPageSize: action,
      updateAwrs: action,
      updateValidatorAwrs: action,
    });
  }

  async fetchMongoUsers(eids = [], locationCodes = [], format) {
    // A truthy format (e.g. 'XLSX') means "export the full result set".
    // In that case we must NOT constrain by the current page's limit/offset -
    // the backend streams every matching row. Only the display fetch is paged.
    if (format) {
      return this.exportMongoUsers(eids, locationCodes, format);
    }
    try {
      this.isLoading = true;
      if (eids.length || locationCodes.length) {
        this.currentEids = eids;
        this.currentLocationCodes = locationCodes;
      }
      const offset = this.page * this.pageSize;
      const result = await CMDBApi.fetchMongoUsers(
        this.currentEids,
        this.currentLocationCodes,
        undefined,
        { limit: this.pageSize, offset }
      );
      this.rows = result.data;
      this.totalCount = result.totalCount;
    } catch (e) {
      console.log(
        'Error caught while fetching learners AWR bulk edit',
        JSON.stringify(e)
      );
    } finally {
      this.isLoading = false;
    }
  }

  // Exports the FULL result set (all matching rows), not just the current page.
  // Reuses the currently active filters when explicit eids/locationCodes are
  // not provided so the export always matches what the search is showing.
  async exportMongoUsers(eids = [], locationCodes = [], format = 'XLSX') {
    try {
      this.isExporting = true;
      const exportEids = eids.length > 0 ? eids : this.currentEids;
      const exportLocationCodes =
        locationCodes.length > 0 ? locationCodes : this.currentLocationCodes;
      await CMDBApi.exportMongoUsers(exportEids, exportLocationCodes, format);
    } catch (e) {
      console.log(
        'Error caught while exporting learners AWR bulk edit',
        JSON.stringify(e)
      );
    } finally {
      this.isExporting = false;
    }
  }

  setPage(page) {
    this.page = page;
    this.fetchMongoUsers();
  }

  setPageSize(pageSize) {
    this.pageSize = pageSize;
    this.page = 0;
    this.fetchMongoUsers();
  }
  async updateAwrs(payload) {
    try {
      this.isLoading = true;
      const { status } = await CMDBApi.updateAwrs(payload);
      return {
        status,
        message: 'awrs have been updated successfully',
      };
    } catch (e) {
      console.log('Error in updating Awrs', e);
      return {
        status: 500,
        message: '',
      };
    } finally {
      this.isLoading = false;
    }
  }

  async updateValidatorAwrs(payload) {
    try {
      this.isLoading = true;
      const { status } = await CMDBApi.updateValidatorAwrs(payload);
      return {
        status,
        message: 'awrs have been updated successfully',
      };
    } catch (e) {
      console.log('Error in updating Awrs', e);
      return {
        status: 500,
        message: '',
      };
    } finally {
      this.isLoading = false;
    }
  }
}

export default new AwrStore();
